import PageLayout from "@layouts/PageLayout";
import { paths } from "@utils/navigation";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

const UnauthorizedRedirection = () => {
  const { i18n } = useTranslation();
  const language = i18n?.language ?? "en";
  const dir = language === "ar" ? "rtl" : "ltr";
  const from = location.pathname + location.search + location.hash;
  return (
    <PageLayout dir={dir}>
      <Navigate to={paths.unauthorized} replace state={{ from }} />
    </PageLayout>
  );
};

export default UnauthorizedRedirection;
